@if(loading) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Buscando'"></app-loader>
  </div>
}

<!-- Photo/Signature dialog -->
<p-dialog [(visible)]="showModalContent" [modal]="true" [style]="{width: '800px', maxHeight: '85vh'}" [dismissableMask]="true"
  [header]="isSignature ? 'Firma' : 'Fotocargas'" (onHide)="signature='';photos=[]">

  @if(loadingContent) {
    <div class="flex justify-center items-center py-12">
      <i class="pi pi-spin pi-spinner text-3xl text-vivid-royal-400"></i>
    </div>
  } @else if(isSignature) {
    <div class="flex justify-center p-4">
      <div class="bg-gray-50 dark:bg-vivid-royal-900 border border-dark-khaki-200 dark:border-vivid-royal-700 rounded-xl p-6 inline-block">
        @if(signature && signature !== '') {
          <p-image [src]="'data:image/png;base64,'+signature" alt="Firma" width="400" [preview]="true" />
        } @else {
          <p class="text-sm text-vivid-royal-400 text-center py-8">Sin firma disponible</p>
        }
      </div>
    </div>
  } @else {
    @if(photos.length === 0) {
      <p class="text-sm text-vivid-royal-400 text-center py-8">Sin fotocargas disponibles</p>
    } @else {
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        @for(photo of photos; track $index) {
          <div class="bg-gray-50 dark:bg-vivid-royal-900 border border-dark-khaki-200 dark:border-vivid-royal-700 rounded-xl overflow-hidden">
            <div class="p-3 flex justify-center">
              <p-image [src]="photo.photo ? 'data:image/png;base64,'+photo.photo : ''" alt="Fotocarga" width="220" [preview]="true" />
            </div>
            <div class="px-3 pb-3 text-center">
              <span class="text-xs font-medium text-vivid-royal-500 dark:text-vivid-royal-300">{{ getPhotoLabel(photo.photoType) }}</span>
            </div>
          </div>
        }
      </div>
    }
  }
</p-dialog>

<div class="px-5 w-full container mx-auto space-y-5">

  <!-- Filters card -->
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 space-y-4">

    <!-- Dates + actions -->
    <div class="space-y-3">
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Fechas</label>
        <app-datepicker (updateDates)="setDatesOnFilter($event)" [selectedFilterRange]="2"></app-datepicker>
      </div>
      <div class="flex gap-2 justify-end">
        <button pButton label="Buscar" icon="pi pi-search" class="p-button-sm flex-1 sm:flex-none" (click)="getConsumptions()"></button>
        <button pButton [icon]="showAdvancedFilters ? 'pi pi-filter-slash' : 'pi pi-filter'" class="p-button-sm p-button-outlined"
          [pTooltip]="showAdvancedFilters ? 'Ocultar filtros' : 'Más filtros'" (click)="showAdvancedFilters = !showAdvancedFilters"></button>
      </div>
    </div>

    <!-- Advanced filters (collapsible) -->
    @if(showAdvancedFilters) {
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4 pt-3 border-t border-dark-khaki-200 dark:border-vivid-royal-700">
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Estación</label>
          <p-select [options]="stations" [(ngModel)]="selectedStation" optionLabel="text" optionValue="value"
            [filter]="stations.length > 10" filterPlaceholder="Buscar..." class="w-full" />
        </div>
        <div [class]="fromCard !== -1 ? 'md:col-span-2' : ''">
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Tarjetas</label>
          <div class="flex items-center gap-2">
            @if(fromCard === -1) {
              <p-select [options]="fromDevices" [(ngModel)]="fromCard" optionLabel="text" optionValue="value"
                (onChange)="changeDeviceFilter($event, true)" [filter]="fromDevices.length > 10" filterPlaceholder="Buscar..." class="w-full" />
            } @else {
              <p-select [options]="fromDevices" [(ngModel)]="fromCard" optionLabel="text" optionValue="value"
                (onChange)="changeDeviceFilter($event, true)" [filter]="fromDevices.length > 10" filterPlaceholder="Buscar..." class="flex-1" />
              <span class="text-xs text-vivid-royal-400 flex-shrink-0">a</span>
              <p-select [options]="toDevices" [(ngModel)]="toCard" optionLabel="text" optionValue="value"
                (onChange)="changeDeviceFilter($event, false)" [filter]="toDevices.length > 10" filterPlaceholder="Buscar..." class="flex-1" />
            }
          </div>
        </div>
        @if(isRedcoClient) {
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Gasolinero</label>
            <input pInputText type="text" [(ngModel)]="redcoData" mask="9999999" autocomplete="off" placeholder="Número" class="w-full" />
          </div>
        }
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Folio Factura</label>
          <input pInputText type="text" [(ngModel)]="folioFactura" mask="9999999" autocomplete="off" placeholder="Numérico" class="w-full" />
        </div>
      </div>
    }
  </div>

  <!-- Results -->
  <!-- Vista toggle + Results -->
  @if(consumptions) {
    <div class="flex items-center justify-between">
      <span class="text-xs text-vivid-royal-400">{{ consumptions.length }} resultado{{ consumptions.length !== 1 ? 's' : '' }}</span>
      <div class="flex items-center gap-2">
        <span class="text-xs text-vivid-royal-400">Vista:</span>
        <p-selectbutton [options]="viewOptions" [(ngModel)]="viewType" optionLabel="label" optionValue="value" [allowEmpty]="false" />
      </div>
    </div>
    @if(viewType === 0) {
      <app-custom-table [rowsByPage]="50" [headers]="headers" [elements]="consumptions"
        [actions]="consumptionsButtons" [hasButton]="true" [hasFilter]="true" [hasColumnFilter]="false" [hasDownload]="true"
        [downloadOptions]="downloadOptions" (downloadAction)="download($event)"></app-custom-table>
    } @else {
      <div class="space-y-4">
        
          <div class="flex justify-end">
            <button pButton label="Imprimir" icon="pi pi-print" class="p-button-sm p-button-outlined" (click)="generateReportConsumptions()"></button>
          </div>
        
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
          @for(ticket of consumptions | paginate:pagTickets; track ticket) {
            <app-ticket [data]="ticket" [clientId]="data.Client_id"></app-ticket>
          }
        </div>
        <div class="w-full">
          <pagination-template *ngIf="consumptions.length > 8" #pData="paginationApi" [id]="pagTickets.id!"
            (pageChange)="pagTickets.currentPage = $event">
            <app-paginator [paginationData]="pData"></app-paginator>
          </pagination-template>
        </div>
      </div>
    }
  }
</div>


